(() => {
  function initialize(root = document) {
    const widgets = [...root.querySelectorAll('[data-sg-led-tabs]')];
    if (root.matches?.('[data-sg-led-tabs]')) widgets.unshift(root);
    widgets.forEach((widget) => {
      if (widget.dataset.tabsInitialized) return;
      const list = widget.querySelector('ul.tabs');
      const tabs = [...list.querySelectorAll('a')];
      const panels = tabs.map((tab) => widget.querySelector(tab.getAttribute('href')));
      if (panels.some((panel) => !panel)) return;
      widget.dataset.tabsInitialized = 'true';
      list.setAttribute('role', 'tablist');
      tabs.forEach((tab, index) => {
        tab.id = `${panels[index].id}-control`;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panels[index].id);
        panels[index].setAttribute('role', 'tabpanel');
        panels[index].setAttribute('aria-labelledby', tab.id);
        panels[index].tabIndex = 0;
        tab.parentElement.setAttribute('role', 'presentation');
      });
      function select(index, focus = false) {
        tabs.forEach((tab, i) => {
          const active = i === index;
          tab.classList.toggle('active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          panels[i].classList.toggle('active', active);
          panels[i].hidden = !active;
          panels[i].style.removeProperty('display');
        });
        if (focus) tabs[index].focus();
      }
      select(Math.max(0, tabs.findIndex((tab) => tab.classList.contains('active'))));
      list.addEventListener('click', (event) => {
        const index = tabs.indexOf(event.target.closest('a'));
        if (index < 0) return;
        event.preventDefault();
        select(index);
      });
      list.addEventListener('keydown', (event) => {
        const index = tabs.indexOf(event.target.closest('a'));
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        select(next, true);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
